<div class="container">
  <div class="row">
    <div class="col-sm-12 pb-3">
      <a class="text-dark" [routerLink]="['/supervisor']"><i class="fa fa-arrow-left"></i> Back to list</a>
    </div>
  </div>

  <manage-interactive-session [sessionId]="sessionId" [zoomId]="zoomId" [isPresenter]="false"></manage-interactive-session>
</div>
